import { useEffect } from 'react';
import theme from '../../theme';
import PageHeader from '../../components/PageHeader';

// Rendered in place of the real /learn routes whenever Clerk isn't
// configured (see lib/clerkConfig.js) -- e.g. in any environment that hasn't
// had CLERK_SECRET_KEY / REACT_APP_CLERK_PUBLISHABLE_KEY set yet.
function LmsComingSoonPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Learn - Austrian Process";
  }, []);

  return (
    <div className="page-container">
      <PageHeader
        title="Learn"
        description="Structured lessons through Austrian economics are on their way."
      />
      <p style={{ color: theme.textMuted, fontFamily: "'EB Garamond', serif", fontSize: '16.5px', lineHeight: 1.7 }}>
        This section isn't live yet. In the meantime, the same material is already covered in{' '}
        <a href="/explainers" style={{ color: theme.gold }}>Explainers</a>.
      </p>
    </div>
  );
}

export default LmsComingSoonPage;
